import { Subject } from 'rxjs/Subject';

/**
 * Return an empty Subject
 * @ignore
 */
export const getEmptySubject = <T>() => new Subject<T>();
